import React from 'react';
import { createUseStyles } from 'react-jss';

function SearchCat2(props) {
const st=styles();
  return (
    <div className={st.container}>SearchCat2</div>
  );
}

const styles = createUseStyles({
  container: {}
});

export default SearchCat2;